/**
 * This file is part of vue-boilerplate.
 * @link     : https://zhaiyiming.com/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 TINYMINS.
 */
import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import { isInDevMode } from '@/utils/environment';
// globle and common
// import * as getters   from './getters'
// import * as actions   from './actions'
// import * as mutations from './mutations';
import commonModule, { StoreCommonState } from './common';
import userModule, { StoreUserState } from './user';
import gameModule, { StoreGameState } from './game';
import secretModule, { StoreSecretState } from './secret';
import jx3Module, { StoreJx3State } from './jx3';
import quizModule, { StoreQuizState } from './quiz';
import playModule, { StorePlayState } from './play';
import chatModule, { StoreChatState } from './chat';
import loggerModule, { StoreLoggerState } from './logger';

Vue.use(Vuex);

export interface StoreRootState {
  common: StoreCommonState;
  user: StoreUserState;
  game: StoreGameState;
  secret: StoreSecretState;
  jx3: StoreJx3State;
  quiz: StoreQuizState;
  play: StorePlayState;
  chat: StoreChatState;
  logger: StoreLoggerState;
}

const store: Store<StoreRootState> = new Vuex.Store<StoreRootState>({
  strict: isInDevMode(),
  modules: {
    common: commonModule,
    user: userModule,
    game: gameModule,
    secret: secretModule,
    jx3: jx3Module,
    quiz: quizModule,
    play: playModule,
    chat: chatModule,
    logger: loggerModule,
  },
  // state,
  // getters,
  // actions,
  // mutations,
});
export default store;
